import { readTabUserData } from "./tabAuthStorage";

const PREFIX = "xproAgendaGooglePromptDismissed";

function storageKey() {
  try {
    const ud = readTabUserData();
    if (ud) {
      const uid = ud?.id ?? ud?.userId;
      if (uid != null && String(uid).trim()) {
        return `${PREFIX}:${String(uid).trim()}`;
      }
    }
  } catch {
    /* ignore */
  }
  return PREFIX;
}

export function readAgendaGooglePromptDismissed() {
  try {
    return localStorage.getItem(storageKey()) === "1";
  } catch {
    return false;
  }
}

export function persistAgendaGooglePromptDismissed() {
  try {
    localStorage.setItem(storageKey(), "1");
  } catch {
    /* ignore */
  }
}
